<script setup>
import { ref, reactive, defineProps, onMounted, computed } from "vue";
import { apiQuery } from "@/api/j24api";

const props = defineProps({
  serialNumber: String,
  licenseId: String,
});

const loading = ref(false);
const logs = reactive([]);
const noDataText = ref("Loading...");

// Add sortBy ref for default sorting
const sortBy = ref([{ key: "datetime", order: "desc" }]);

onMounted(() => {
  getPatchLogs();
});

async function getPatchLogs() {
  loading.value = true;
  try {
    let result = await apiQuery("ELA", "patching/patchingManagement", {
      action: "getDeviceLogs",
      serial: props.serialNumber,
      id: props.licenseId,
    });
    logs.length = 0;
    if (result.length) {
      logs.push(...result);
    }
  } catch (error) {
    console.error("Error getting patch logs", error);
  }
  if (logs.length === 0) {
    noDataText.value = "No logs found";
  }
  loading.value = false;
}

const headers = [
  { title: "Date / Time", value: "datetime", sortable: true },
  { title: "Type", value: "errorType", sortable: true },
  { title: "Message", value: "body", sortable: true },
];

const hasExtendedLogs = computed(() => {
  return logs.some((log) => log.extended === true);
});
</script>
<template>
  <v-sheet rounded="lg" elevation="1" class="ma-1">
    <v-row class="ma-0 pa-0" align="center">
      <v-col cols="auto">
        <h2 class="ml-3 pt-2">Patch Logs</h2>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" v-if="hasExtendedLogs">
        <v-sheet class="d-flex align-center">
          <v-sheet
            class="mr-2"
            :height="16"
            :width="16"
            color="blue-lighten-4"
          ></v-sheet>
          <span class="text-body-2">= Extended Log Entry</span>
        </v-sheet>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="logs"
      :loading="loading"
      :no-data-text="noDataText"
      v-model:sort-by="sortBy"
    >
      <template v-slot:[`item.datetime`]="{ item }">
        {{ new Date(item.datetime).toLocaleString() }}
      </template>
      <template v-slot:item="{ item }">
        <tr :class="{ 'bg-blue-lighten-4': item.extended }">
          <td>{{ new Date(item.datetime).toLocaleString() }}</td>
          <td>{{ item.errorType }}</td>
          <td>{{ item.body }}</td>
        </tr>
      </template>
      <template #no-data>
        <v-alert type="info" class="ma-2">
          {{ noDataText }}
        </v-alert>
      </template>
    </v-data-table>
  </v-sheet>
</template>
